/**
 * @generated SignedSource<<f7598e7b3bf320375d5d01546e381eea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DirectoryViewPeopleQuery$variables = {
  cloudId: string;
  includeManagerData: boolean;
  includeTeams: boolean;
  organisationId: string;
  peopleQuery: string;
};
export type DirectoryViewPeopleQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryView_PeoplePaginationQuery">;
};
export type DirectoryViewPeopleQuery = {
  response: DirectoryViewPeopleQuery$data;
  variables: DirectoryViewPeopleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeManagerData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTeams"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "peopleQuery"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v7 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  },
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "peopleQuery"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryViewPeopleQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "includeManagerData",
            "variableName": "includeManagerData"
          },
          {
            "kind": "Variable",
            "name": "includeTeams",
            "variableName": "includeTeams"
          },
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "peopleQuery",
            "variableName": "peopleQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "DirectoryView_PeoplePaginationQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryViewPeopleQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "CpusSearchUserConnection",
        "kind": "LinkedField",
        "name": "peopleTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CpusSearchUserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "CpusSearchUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "account_id"
                  },
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "job_title"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "location"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "department"
                  },
                  (v9/*: any*/),
                  {
                    "condition": "includeTeams",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "TeamSearchResponseConnection",
                        "kind": "LinkedField",
                        "name": "searchTeams",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamSearchResponse",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "teamId",
                                    "kind": "ScalarField",
                                    "name": "id"
                                  },
                                  {
                                    "alias": "name",
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                  },
                                  {
                                    "alias": "avatarUrl",
                                    "kind": "ScalarField",
                                    "name": "smallAvatarImageUrl"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isVerified"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "count"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "includeManagerData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "managerData",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "size",
                        "value": "MEDIUM"
                      }
                    ],
                    "concreteType": "HighResolutionProfilePicture",
                    "kind": "LinkedField",
                    "name": "highResolutionProfilePicture",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      }
                    ],
                    "storageKey": "highResolutionProfilePicture(size:\"MEDIUM\")"
                  },
                  (v10/*: any*/)
                ]
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "filters": [
          "q",
          "organisationId",
          "cloudId"
        ],
        "handle": "connection",
        "key": "PeopleDirectoryPagination_peopleTql",
        "kind": "LinkedHandle",
        "name": "peopleTql"
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "wrapTextEnabled"
              },
              (v11/*: any*/)
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "45d3e66a98699df65daa0ceef6824ce5",
    "id": null,
    "metadata": {},
    "name": "DirectoryViewPeopleQuery",
    "operationKind": "query",
    "text": "query DirectoryViewPeopleQuery(\n  $peopleQuery: String!\n  $includeManagerData: Boolean!\n  $includeTeams: Boolean!\n  $organisationId: String!\n  $cloudId: String!\n) {\n  ...DirectoryView_PeoplePaginationQuery_30gU9f\n}\n\nfragment DirectoryRow_PeopleDirectory_232kp0 on CpusSearchUser {\n  account_id\n  name\n  job_title\n  location\n  department\n  picture\n  searchTeams @include(if: $includeTeams) {\n    ...UserTeams\n  }\n  managerData @include(if: $includeManagerData) {\n    accountId\n    name\n    picture\n  }\n}\n\nfragment DirectoryView_PeoplePaginationQuery_30gU9f on Query {\n  peopleTql(q: $peopleQuery, organisationId: $organisationId, cloudId: $cloudId, first: 24) {\n    ...DirectoryView_PeopleResults_232kp0\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  currentUser {\n    preferences {\n      wrapTextEnabled\n      id\n    }\n    id\n  }\n}\n\nfragment DirectoryView_PeopleResults_232kp0 on CpusSearchUserConnection {\n  ...PeopleDirectoryListView_232kp0\n  ...PeopleDirectoryGridView\n}\n\nfragment PeopleDirectoryGridView on CpusSearchUserConnection {\n  edges {\n    node {\n      account_id\n      ...UserCard_PeopleDirectory\n    }\n  }\n  pageInfo {\n    hasNextPage\n  }\n}\n\nfragment PeopleDirectoryListView_232kp0 on CpusSearchUserConnection {\n  edges {\n    node {\n      account_id\n      ...DirectoryRow_PeopleDirectory_232kp0\n    }\n  }\n  pageInfo {\n    hasNextPage\n  }\n}\n\nfragment UserCard_PeopleDirectory on CpusSearchUser {\n  account_id\n  name\n  highResolutionProfilePicture(size: MEDIUM) {\n    url\n  }\n  job_title\n  location\n}\n\nfragment UserTeams on TeamSearchResponseConnection {\n  edges {\n    node {\n      teamId: id\n      name: displayName\n      avatarUrl: smallAvatarImageUrl\n      isVerified\n    }\n  }\n  count\n}\n"
  }
};
})();

(node as any).hash = "96eb7de2a8b4726b4468a8413a366bc0";

export default node;
